import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Tally5: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M4 4v16' }],
    ['path', { d: 'M9 4v16' }],
    ['path', { d: 'M14 4v16' }],
    ['path', { d: 'M19 4v16' }],
    ['path', { d: 'M22 6 2 18' }],
  ],
];

export default Tally5;
